import { render, staticRenderFns } from "./ElasticChatStartup.vue?vue&type=template&id=bbeadd02&scoped=true&"
import script from "./ElasticChatStartup.vue?vue&type=script&setup=true&lang=js&"
export * from "./ElasticChatStartup.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ElasticChatStartup.vue?vue&type=style&index=0&id=bbeadd02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbeadd02",
  null
  
)

export default component.exports